import { createEntityAdapter } from '@reduxjs/toolkit'

export const savedCreditCardAdapter =
  createEntityAdapter<User.SavedCreditCard>()
